export enum StatiPredefiniti {
  Archivio = 1,
  Evidenza = 2,
  Trattazione = 3,
  Declassificato = 8,
  Elevato = 9,
  Distrutto = 10,
  Prorogato = 11,
  Annullato = 15,
  Versato = 16,
  Acquisito = 17,
  Riprodotto = 21,
  Spedito = 22
}
